export const CHANNEL_LABELS: Record<string, string> = {
  SITE: '사이트(토스)',
  SMARTSTORE: '스마트스토어',
}

// 상품 유형 라벨 (payment_type enum → 한국어)
export const PRODUCT_TYPE_LABELS: Record<string, string> = {
  INVITATION_MAIN: '청첩장',
  INVITATION_PACKAGE: '청첩장 패키지',
  ALL_PACKAGE: '올인원 패키지',
  THANKS_PACKAGE: '감사장 패키지',
  THANKYOU_ADDON: '감사장 추가상품',
  SNAP_MAIN: '스냅',
  SNAP_PHOTOS_10: '스냅 사진 10',
  SNAP_PHOTOS_20: '스냅 사진 20',
  STUDIO_PHOTOS_10: '스튜디오 사진 10',
  STUDIO_PHOTOS_20: '스튜디오 사진 20',
  STUDIO_PHOTOS_30: '스튜디오 사진 30',
  AI_CREDITS: 'AI 크레딧',
  AI_CREDITS_BUNDLE: 'AI 크레딧 번들',
  PREMIUM_UPGRADE: '프리미엄 업그레이드',
  CREDITS_10: '크레딧 10',
  CREDITS_20: '크레딧 20',
  CREDITS_30: '크레딧 30',
  CREDITS_50: '크레딧 50',
  CREDITS_100: '크레딧 100',
}

// 가입 시점 버킷 라벨 (서버의 정렬 프리픽스 제거용)
export const BUCKET_LABELS: Record<string, string> = {
  '0. 유입미상(미활성화)': '유입미상(미활성화)',
  '1. 기간 내 가입(즉시 전환)': '기간 내 가입(즉시)',
  '2. 1주 내 가입': '1주 내 가입',
  '3. 한 달 내 가입': '한 달 내 가입',
  '4. 한 달 이전 가입(장기 지연)': '한 달 이전(장기)',
}

export const WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토']
